export default __webpack_public_path__ + "static/media/property_185.9a72229b.png";